import React from 'react';
import { Route } from '../Routing/types';
import { WearablesPage, WearablesDashboardPage } from '@front-activerse/modules';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/wearables',
    element: <WearablesPage redirectUri={`${window.location.origin}/wearables`} />,
    private: true,
    title: dummy_t('wearables.navigation_title'),
    mobileAppTabIdentifier: '',
  },
  {
    path: '/wearables/dashboard',
    element: <WearablesDashboardPage />,
    private: true,
    title: '',
    mobileAppTabIdentifier: '',
  },
];

export default routes;
